module.exports = __webpack_public_path__ + "c0d3276ed8665afb8e1924d1f913c86d.svg";